import { _ as create3, a as listRootTab, c as getSizeByProjectId, d as getModelSectionFileMeta, f as getCommentSectionFileMeta, g as createFromTemplate, h as delete8, i as move6, l as getSizeByDirectoryIds, m as documentsCount, n as revisionsCount, o as listRoot, p as getBuildingManagementDocumentSectionFileMeta, r as rename8, s as list8, t as revisionsGroupById, u as getRoot } from "./revisionsGroupById2.js";
import { mutationOptions, queryOptions, useMutation, useQuery } from "@tanstack/react-query";
//#region src/__generated__/filesystem-gge/directories/hooks/useCreate3.ts
const create3MutationKey = () => [{ url: "/directory" }];
function create3MutationOptions(config = {}) {
	const mutationKey = create3MutationKey();
	return mutationOptions({
		mutationKey,
		mutationFn: async ({ body }) => {
			const { data } = await create3({
				...config,
				body,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Создать папку.
* {@link /directory}
*/
function useCreate3(options = {}) {
	const { mutation = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...mutationOptions } = mutation;
	const mutationKey = mutationOptions.mutationKey ?? create3MutationKey();
	const baseOptions = create3MutationOptions(config);
	return useMutation({
		...baseOptions,
		mutationKey,
		...mutationOptions
	}, queryClient);
}
//#endregion
//#region src/__generated__/filesystem-gge/directories/hooks/useCreateFromTemplate.ts
const createFromTemplateMutationKey = () => [{ url: "/directory/template" }];
function createFromTemplateMutationOptions(config = {}) {
	const mutationKey = createFromTemplateMutationKey();
	return mutationOptions({
		mutationKey,
		mutationFn: async ({ body }) => {
			const { data } = await createFromTemplate({
				...config,
				body,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Создать шаблон для проекта.
* {@link /directory/template}
*/
function useCreateFromTemplate(options = {}) {
	const { mutation = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...mutationOptions } = mutation;
	const mutationKey = mutationOptions.mutationKey ?? createFromTemplateMutationKey();
	const baseOptions = createFromTemplateMutationOptions(config);
	return useMutation({
		...baseOptions,
		mutationKey,
		...mutationOptions
	}, queryClient);
}
//#endregion
//#region src/__generated__/filesystem-gge/directories/hooks/useDelete8.ts
const delete8MutationKey = () => [{ url: "/directory/:id" }];
function delete8MutationOptions(config = {}) {
	const mutationKey = delete8MutationKey();
	return mutationOptions({
		mutationKey,
		mutationFn: async ({ path }) => {
			const { data } = await delete8({
				...config,
				path,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Удалить папку.
* {@link /directory/:id}
*/
function useDelete8(options = {}) {
	const { mutation = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...mutationOptions } = mutation;
	const mutationKey = mutationOptions.mutationKey ?? delete8MutationKey();
	const baseOptions = delete8MutationOptions(config);
	return useMutation({
		...baseOptions,
		mutationKey,
		...mutationOptions
	}, queryClient);
}
//#endregion
//#region src/__generated__/filesystem-gge/directories/hooks/useDocumentsCount.ts
const documentsCountQueryKey = ({ path }) => [{
	url: "/directory/:directoryId/documents/count",
	params: path
}];
function documentsCountQueryOptions({ path }, config = {}) {
	const queryKey = documentsCountQueryKey({ path });
	return queryOptions({
		queryKey,
		queryFn: async ({ signal }) => {
			const { data } = await documentsCount({
				...config,
				path,
				signal: config.signal ?? signal,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Получить количество документов (файлов) в директории, не считая их версий.
* {@link /directory/:directoryId/documents/count}
*/
function useDocumentsCount({ path }, options = {}) {
	const { query: queryConfig = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...resolvedOptions } = queryConfig;
	const resolvedParams = { path: typeof path === "function" ? path() : path };
	const queryKey = resolvedOptions?.queryKey ?? documentsCountQueryKey(resolvedParams);
	const queryResult = useQuery({
		...documentsCountQueryOptions(resolvedParams, config),
		...resolvedOptions,
		queryKey
	}, queryClient);
	queryResult.queryKey = queryKey;
	return queryResult;
}
//#endregion
//#region src/__generated__/filesystem-gge/directories/hooks/useGetBuildingManagementDocumentSectionFileMeta.ts
const getBuildingManagementDocumentSectionFileMetaQueryKey = ({ path }) => [{
	url: "/directory/getBuildingManagementDocumentSectionFileMeta/:id",
	params: path
}];
function getBuildingManagementDocumentSectionFileMetaQueryOptions({ path }, config = {}) {
	const queryKey = getBuildingManagementDocumentSectionFileMetaQueryKey({ path });
	return queryOptions({
		queryKey,
		queryFn: async ({ signal }) => {
			const { data } = await getBuildingManagementDocumentSectionFileMeta({
				...config,
				path,
				signal: config.signal ?? signal,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Получить мета-информацию о папке проекта для хранения документов фото и их превью.
* {@link /directory/getBuildingManagementDocumentSectionFileMeta/:id}
*/
function useGetBuildingManagementDocumentSectionFileMeta({ path }, options = {}) {
	const { query: queryConfig = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...resolvedOptions } = queryConfig;
	const resolvedParams = { path: typeof path === "function" ? path() : path };
	const queryKey = resolvedOptions?.queryKey ?? getBuildingManagementDocumentSectionFileMetaQueryKey(resolvedParams);
	const queryResult = useQuery({
		...getBuildingManagementDocumentSectionFileMetaQueryOptions(resolvedParams, config),
		...resolvedOptions,
		queryKey
	}, queryClient);
	queryResult.queryKey = queryKey;
	return queryResult;
}
//#endregion
//#region src/__generated__/filesystem-gge/directories/hooks/useGetCommentSectionFileMeta.ts
const getCommentSectionFileMetaQueryKey = ({ path }) => [{
	url: "/directory/getCommentSectionFileMeta/:id",
	params: path
}];
function getCommentSectionFileMetaQueryOptions({ path }, config = {}) {
	const queryKey = getCommentSectionFileMetaQueryKey({ path });
	return queryOptions({
		queryKey,
		queryFn: async ({ signal }) => {
			const { data } = await getCommentSectionFileMeta({
				...config,
				path,
				signal: config.signal ?? signal,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Получить мета-информацию о папке проекта для хранения документов комментариев.
* {@link /directory/getCommentSectionFileMeta/:id}
*/
function useGetCommentSectionFileMeta({ path }, options = {}) {
	const { query: queryConfig = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...resolvedOptions } = queryConfig;
	const resolvedParams = { path: typeof path === "function" ? path() : path };
	const queryKey = resolvedOptions?.queryKey ?? getCommentSectionFileMetaQueryKey(resolvedParams);
	const queryResult = useQuery({
		...getCommentSectionFileMetaQueryOptions(resolvedParams, config),
		...resolvedOptions,
		queryKey
	}, queryClient);
	queryResult.queryKey = queryKey;
	return queryResult;
}
//#endregion
//#region src/__generated__/filesystem-gge/directories/hooks/useGetModelSectionFileMeta.ts
const getModelSectionFileMetaQueryKey = ({ path }) => [{
	url: "/directory/getModelSectionFileMeta/:id",
	params: path
}];
function getModelSectionFileMetaQueryOptions({ path }, config = {}) {
	const queryKey = getModelSectionFileMetaQueryKey({ path });
	return queryOptions({
		queryKey,
		queryFn: async ({ signal }) => {
			const { data } = await getModelSectionFileMeta({
				...config,
				path,
				signal: config.signal ?? signal,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Получить мета-информацию о папке проекта для хранения моделей (ifc файлы).
* {@link /directory/getModelSectionFileMeta/:id}
*/
function useGetModelSectionFileMeta({ path }, options = {}) {
	const { query: queryConfig = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...resolvedOptions } = queryConfig;
	const resolvedParams = { path: typeof path === "function" ? path() : path };
	const queryKey = resolvedOptions?.queryKey ?? getModelSectionFileMetaQueryKey(resolvedParams);
	const queryResult = useQuery({
		...getModelSectionFileMetaQueryOptions(resolvedParams, config),
		...resolvedOptions,
		queryKey
	}, queryClient);
	queryResult.queryKey = queryKey;
	return queryResult;
}
//#endregion
//#region src/__generated__/filesystem-gge/directories/hooks/useGetRoot.ts
const getRootQueryKey = ({ path }) => [{
	url: "/directory/getRoot/:id",
	params: path
}];
function getRootQueryOptions({ path }, config = {}) {
	const queryKey = getRootQueryKey({ path });
	return queryOptions({
		queryKey,
		queryFn: async ({ signal }) => {
			const { data } = await getRoot({
				...config,
				path,
				signal: config.signal ?? signal,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Получить мета-информацию о корневой папке по переданному id.
* {@link /directory/getRoot/:id}
*/
function useGetRoot({ path }, options = {}) {
	const { query: queryConfig = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...resolvedOptions } = queryConfig;
	const resolvedParams = { path: typeof path === "function" ? path() : path };
	const queryKey = resolvedOptions?.queryKey ?? getRootQueryKey(resolvedParams);
	const queryResult = useQuery({
		...getRootQueryOptions(resolvedParams, config),
		...resolvedOptions,
		queryKey
	}, queryClient);
	queryResult.queryKey = queryKey;
	return queryResult;
}
//#endregion
//#region src/__generated__/filesystem-gge/directories/hooks/useGetSizeByDirectoryIds.ts
const getSizeByDirectoryIdsMutationKey = () => [{ url: "/directory/size/dir" }];
function getSizeByDirectoryIdsMutationOptions(config = {}) {
	const mutationKey = getSizeByDirectoryIdsMutationKey();
	return mutationOptions({
		mutationKey,
		mutationFn: async ({ body }) => {
			const { data } = await getSizeByDirectoryIds({
				...config,
				body,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @description Возвращает мапу, где ключ - идентификатор директории, а значение - размер.
* @summary Получить примерный размер директорий в байтах по идентификаторам.
* {@link /directory/size/dir}
*/
function useGetSizeByDirectoryIds(options = {}) {
	const { mutation = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...mutationOptions } = mutation;
	const mutationKey = mutationOptions.mutationKey ?? getSizeByDirectoryIdsMutationKey();
	const baseOptions = getSizeByDirectoryIdsMutationOptions(config);
	return useMutation({
		...baseOptions,
		mutationKey,
		...mutationOptions
	}, queryClient);
}
//#endregion
//#region src/__generated__/filesystem-gge/directories/hooks/useGetSizeByProjectId.ts
const getSizeByProjectIdQueryKey = ({ path }) => [{
	url: "/directory/:projectId/size",
	params: path
}];
function getSizeByProjectIdQueryOptions({ path }, config = {}) {
	const queryKey = getSizeByProjectIdQueryKey({ path });
	return queryOptions({
		queryKey,
		queryFn: async ({ signal }) => {
			const { data } = await getSizeByProjectId({
				...config,
				path,
				signal: config.signal ?? signal,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Получить размер директории по проекту.
* {@link /directory/:projectId/size}
*/
function useGetSizeByProjectId({ path }, options = {}) {
	const { query: queryConfig = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...resolvedOptions } = queryConfig;
	const resolvedParams = { path: typeof path === "function" ? path() : path };
	const queryKey = resolvedOptions?.queryKey ?? getSizeByProjectIdQueryKey(resolvedParams);
	const queryResult = useQuery({
		...getSizeByProjectIdQueryOptions(resolvedParams, config),
		...resolvedOptions,
		queryKey
	}, queryClient);
	queryResult.queryKey = queryKey;
	return queryResult;
}
//#endregion
//#region src/__generated__/filesystem-gge/directories/hooks/useList8.ts
const list8QueryKey = ({ path }) => [{
	url: "/directory/:id",
	params: path
}];
function list8QueryOptions({ path }, config = {}) {
	const queryKey = list8QueryKey({ path });
	return queryOptions({
		queryKey,
		queryFn: async ({ signal }) => {
			const { data } = await list8({
				...config,
				path,
				signal: config.signal ?? signal,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Получить контент папки.
* {@link /directory/:id}
*/
function useList8({ path }, options = {}) {
	const { query: queryConfig = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...resolvedOptions } = queryConfig;
	const resolvedParams = { path: typeof path === "function" ? path() : path };
	const queryKey = resolvedOptions?.queryKey ?? list8QueryKey(resolvedParams);
	const queryResult = useQuery({
		...list8QueryOptions(resolvedParams, config),
		...resolvedOptions,
		queryKey
	}, queryClient);
	queryResult.queryKey = queryKey;
	return queryResult;
}
//#endregion
//#region src/__generated__/filesystem-gge/directories/hooks/useListRoot.ts
const listRootQueryKey = ({ path }) => [{
	url: "/directory/root/:id",
	params: path
}];
function listRootQueryOptions({ path }, config = {}) {
	const queryKey = listRootQueryKey({ path });
	return queryOptions({
		queryKey,
		queryFn: async ({ signal }) => {
			const { data } = await listRoot({
				...config,
				path,
				signal: config.signal ?? signal,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Получить контент корневой папки по переданному id.
* {@link /directory/root/:id}
*/
function useListRoot({ path }, options = {}) {
	const { query: queryConfig = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...resolvedOptions } = queryConfig;
	const resolvedParams = { path: typeof path === "function" ? path() : path };
	const queryKey = resolvedOptions?.queryKey ?? listRootQueryKey(resolvedParams);
	const queryResult = useQuery({
		...listRootQueryOptions(resolvedParams, config),
		...resolvedOptions,
		queryKey
	}, queryClient);
	queryResult.queryKey = queryKey;
	return queryResult;
}
//#endregion
//#region src/__generated__/filesystem-gge/directories/hooks/useListRootTab.ts
const listRootTabQueryKey = ({ path }) => [{
	url: "/directory/root/:id/tab/:directoryTab",
	params: path
}];
function listRootTabQueryOptions({ path }, config = {}) {
	const queryKey = listRootTabQueryKey({ path });
	return queryOptions({
		queryKey,
		queryFn: async ({ signal }) => {
			const { data } = await listRootTab({
				...config,
				path,
				signal: config.signal ?? signal,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Получить контент корневой папки по переданному id и вкладке.
* {@link /directory/root/:id/tab/:directoryTab}
*/
function useListRootTab({ path }, options = {}) {
	const { query: queryConfig = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...resolvedOptions } = queryConfig;
	const resolvedParams = { path: typeof path === "function" ? path() : path };
	const queryKey = resolvedOptions?.queryKey ?? listRootTabQueryKey(resolvedParams);
	const queryResult = useQuery({
		...listRootTabQueryOptions(resolvedParams, config),
		...resolvedOptions,
		queryKey
	}, queryClient);
	queryResult.queryKey = queryKey;
	return queryResult;
}
//#endregion
//#region src/__generated__/filesystem-gge/directories/hooks/useMove6.ts
const move6MutationKey = () => [{ url: "/directory/move" }];
function move6MutationOptions(config = {}) {
	const mutationKey = move6MutationKey();
	return mutationOptions({
		mutationKey,
		mutationFn: async ({ body }) => {
			const { data } = await move6({
				...config,
				body,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Переместить папку.
* {@link /directory/move}
*/
function useMove6(options = {}) {
	const { mutation = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...mutationOptions } = mutation;
	const mutationKey = mutationOptions.mutationKey ?? move6MutationKey();
	const baseOptions = move6MutationOptions(config);
	return useMutation({
		...baseOptions,
		mutationKey,
		...mutationOptions
	}, queryClient);
}
//#endregion
//#region src/__generated__/filesystem-gge/directories/hooks/useRename8.ts
const rename8MutationKey = () => [{ url: "/directory/rename" }];
function rename8MutationOptions(config = {}) {
	const mutationKey = rename8MutationKey();
	return mutationOptions({
		mutationKey,
		mutationFn: async ({ body }) => {
			const { data } = await rename8({
				...config,
				body,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Переименовать папку.
* {@link /directory/rename}
*/
function useRename8(options = {}) {
	const { mutation = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...mutationOptions } = mutation;
	const mutationKey = mutationOptions.mutationKey ?? rename8MutationKey();
	const baseOptions = rename8MutationOptions(config);
	return useMutation({
		...baseOptions,
		mutationKey,
		...mutationOptions
	}, queryClient);
}
//#endregion
//#region src/__generated__/filesystem-gge/directories/hooks/useRevisionsCount.ts
const revisionsCountQueryKey = ({ path }) => [{
	url: "/directory/:directoryId/revisions/count",
	params: path
}];
function revisionsCountQueryOptions({ path }, config = {}) {
	const queryKey = revisionsCountQueryKey({ path });
	return queryOptions({
		queryKey,
		queryFn: async ({ signal }) => {
			const { data } = await revisionsCount({
				...config,
				path,
				signal: config.signal ?? signal,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Получить общее количество ревизий в директории (общее количество файлов, включая все их версии).
* {@link /directory/:directoryId/revisions/count}
*/
function useRevisionsCount({ path }, options = {}) {
	const { query: queryConfig = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...resolvedOptions } = queryConfig;
	const resolvedParams = { path: typeof path === "function" ? path() : path };
	const queryKey = resolvedOptions?.queryKey ?? revisionsCountQueryKey(resolvedParams);
	const queryResult = useQuery({
		...revisionsCountQueryOptions(resolvedParams, config),
		...resolvedOptions,
		queryKey
	}, queryClient);
	queryResult.queryKey = queryKey;
	return queryResult;
}
//#endregion
//#region src/__generated__/filesystem-gge/directories/hooks/useRevisionsGroupById.ts
const revisionsGroupByIdQueryKey = ({ path }) => [{
	url: "/directory/:directoryId/revisions/group/id",
	params: path
}];
function revisionsGroupByIdQueryOptions({ path }, config = {}) {
	const queryKey = revisionsGroupByIdQueryKey({ path });
	return queryOptions({
		queryKey,
		queryFn: async ({ signal }) => {
			const { data } = await revisionsGroupById({
				...config,
				path,
				signal: config.signal ?? signal,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @summary Получить количество ревизий в директории, сгруппированных по ID первой версии файла.
* {@link /directory/:directoryId/revisions/group/id}
*/
function useRevisionsGroupById({ path }, options = {}) {
	const { query: queryConfig = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...resolvedOptions } = queryConfig;
	const resolvedParams = { path: typeof path === "function" ? path() : path };
	const queryKey = resolvedOptions?.queryKey ?? revisionsGroupByIdQueryKey(resolvedParams);
	const queryResult = useQuery({
		...revisionsGroupByIdQueryOptions(resolvedParams, config),
		...resolvedOptions,
		queryKey
	}, queryClient);
	queryResult.queryKey = queryKey;
	return queryResult;
}
//#endregion
export { useGetRoot as A, documentsCountQueryKey as B, getSizeByProjectIdQueryOptions as C, useGetSizeByDirectoryIds as D, getSizeByDirectoryIdsMutationOptions as E, getCommentSectionFileMetaQueryOptions as F, useDelete8 as G, useDocumentsCount as H, useGetCommentSectionFileMeta as I, useCreateFromTemplate as J, createFromTemplateMutationKey as K, getBuildingManagementDocumentSectionFileMetaQueryKey as L, getModelSectionFileMetaQueryOptions as M, useGetModelSectionFileMeta as N, getRootQueryKey as O, getCommentSectionFileMetaQueryKey as P, getBuildingManagementDocumentSectionFileMetaQueryOptions as R, getSizeByProjectIdQueryKey as S, getSizeByDirectoryIdsMutationKey as T, delete8MutationKey as U, documentsCountQueryOptions as V, delete8MutationOptions as W, create3MutationOptions as X, create3MutationKey as Y, useCreate3 as Z, listRootQueryOptions as _, revisionsCountQueryOptions as a, list8QueryOptions as b, rename8MutationOptions as c, move6MutationOptions as d, useMove6 as f, listRootQueryKey as g, useListRootTab as h, revisionsCountQueryKey as i, getModelSectionFileMetaQueryKey as j, getRootQueryOptions as k, useRename8 as l, listRootTabQueryOptions as m, revisionsGroupByIdQueryOptions as n, useRevisionsCount as o, listRootTabQueryKey as p, createFromTemplateMutationOptions as q, useRevisionsGroupById as r, rename8MutationKey as s, revisionsGroupByIdQueryKey as t, move6MutationKey as u, useListRoot as v, useGetSizeByProjectId as w, useList8 as x, list8QueryKey as y, useGetBuildingManagementDocumentSectionFileMeta as z };

//# sourceMappingURL=useRevisionsGroupById2.js.map